import { render, staticRenderFns } from "./TerminationsTable.vue?vue&type=template&id=df9b4de4&scoped=true&"
import script from "./TerminationsTable.vue?vue&type=script&lang=js&"
export * from "./TerminationsTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminationsTable.vue?vue&type=style&index=0&id=df9b4de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b4de4",
  null
  
)

export default component.exports